// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"134":"9d938802","396":"500bf303","923":"968cc81c"}[chunkId] + ".css";
};